document.addEventListener('DOMContentLoaded', function() {
  const radios = document.querySelectorAll('.variant-button');
  const featuredImage = document.querySelector('.featured_image');

  radios.forEach((radio, index) => {
    radio.addEventListener('change', function() {
      featuredImage.classList.remove('first-variant-selected', 'second-variant-selected');
      if (index === 0) {
        featuredImage.classList.add('first-variant-selected');
      } else if (index === 1) {
        featuredImage.classList.add('second-variant-selected');
      }
    });
  });
});